module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/readable-stream/transform.js
// module id = 1710
// module chunks = 1